import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

import { Adal5Service } from 'adal-angular5';
import { adal } from 'adal-angular';

declare var _satellite: any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})

export class ForgotPasswordComponent implements OnInit {

  constructor(private service: Adal5Service) { }

  ngOnInit() {
    if ((environment.qa || environment.production) && typeof _satellite !== 'undefined') {
      _satellite.track("Forgot Password");
    }

    this.service.config.extraQueryParameter = environment.azure_password_reset_paramter;
    this.service.config.redirectUri = window.location.origin + '/docs/account-info';
    this.service.login();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/forgot-password/forgot-password.component.ts